PJQ.views.schedule.SettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Settings'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-delete-tasks': 'deleteTasks'
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.schedule.Settings({
                projectId: this.options.project != null ? this.options.project.id : null
            });
        }
        if (!this.model.isFetched) {
            this.model.fetch({
                success: function () {
                    this.render();
                }
            });
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        if (!this.model.isFetched) {
            return;
        }

        new PJQ.views.schedule.Settings({
            el: this.$('.settings-outer'),
            model: this.model,
            project: this.options.project
        });
    },
    deleteTasks: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete all tasks on this schedule?",
            onDelete: _.bind(function () {
                this.options.project.deleteAllScheduleTasks(_.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                }, this));
            }, this)
        });
    },
    save: function () {
        if (this.model.hasChanged()) {
            this.model.save({}, {
                notify: true,
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.schedule.Settings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Settings'),
        onChange: null
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeFirstRender: function () {
        if (this.model == null) {
            this.model = new PJQ.models.schedule.Settings({
                projectId: this.options.project != null ? this.options.project.id : null
            });
        }
        this.listenTo(this.model, 'change:notificationsEnabled', function () {
            let $notifications = this.$('.notification-settings');
            if (this.model.get('notificationsEnabled')) {
                $notifications.removeClass('hidden');
            } else {
                $notifications.addClass('hidden');
            }
        });

        let listen = _.bind(function () {
            if (typeof this.options.onChange === 'function') {
                this.listenTo(this.model, 'change', function () {
                    this.options.onChange(this.model);
                });
            }
        }, this);
        if (!this.model.isFetched) {
            this.model.fetch({
                success: _.bind(function () {
                    listen();
                    this.render();
                }, this)
            });
        } else {
            listen();
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        if (!this.model.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        if (this.options.project != null) {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.look-ahead-managers'),
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                selectedContact: this.model.lookAheadManagers.models,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    this.model.lookAheadManagers.reset(selectedContacts);
                    this.model.set('isDirty', true);
                }, this)
            });
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-view'),
            defaultValue: this.model.get('defaultView') ? this.model.get('defaultView') : 'view_group',
            onChange: _.bind(function (value) {
                this.model.set('defaultView', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-date-change-notif-mode'),
            defaultValue: this.model.get('dateChangeNotificationsMode'),
            onChange: _.bind(function (value) {
                this.model.set('dateChangeNotificationsMode', value);
            }, this)
        });
    }
});

PJQ.views.schedule.TaskStatuses = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Schedule-Statuses')
    },
    events: {
        'click .add-task-status': 'addClicked',
        'click .edit-task-status': 'editClicked',
        'click .delete-task-status': 'deleteClicked',
        'click .save-task-status': 'statusSave',
        'click .cancel-edit-task-status': 'cancelEditStatus',
        'colorpickerChange': 'setBGColor',
        'keyup .colorpicker-input-box': 'setBGColor'
    },
    beforeFirstRender: function () {
        this.taskStatusContext = null;
        this.collection = new PJQ.collections.schedule.TaskStatuses();
        this.collection.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    renderData: function () {
        return {};
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".task-status-table"),
            isHideSearch: true,
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            sortableOptions: {
                data: this.collection
            },
            targets: 'no-sort',
            pageLength: 50,
            bSort: false,
            language: {
                zeroRecords: 'Click "Add" to create a new Task Status'
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false,
                    "render": _.bind(function (data, type, row) {
                        return '<div><i class="fas fa-sort"></i></div>';
                    }, this)
                },
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.taskStatusContext != null && this.taskStatusContext.get('name') === row.get('name') && this.taskStatusContext.get('sortOrder') === row.get('sortOrder')) {
                                return '<input type="text" class="form-control input-task-status wd-200p" value="' + row.get('name') + '">';
                            } else {
                                return '<span style="color:' + row.get('color') + ';">' + row.get('name') + '</span>';
                            }
                        }, this)
                    },
                    "title": "Status",
                    "width": "200px"
                },
                {
                    "data": "",
                    "title": "Default",
                    "width": "50px",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = row.get('isDefault') === true ? "Yes" : "No";
                        if (this.taskStatusContext != null && this.taskStatusContext.get('name') === row.get('name') && this.taskStatusContext.get('sortOrder') === row.get('sortOrder')) {
                            content = '<div class="pretty p-switch mr-1 wd-120p mr-2 ml-2">\n' +
                                '                <input type="checkbox" class="input-default-status"\n' +
                                '                       />\n' +
                                '                <div class="state p-primary">\n' +
                                '                    <label><span class="fs-16">Default Status</span></label>\n' +
                                '                </div>\n' +
                                '            </div>'
                        }
                        if (this.taskStatusContext != null && this.taskStatusContext.get('isDefault') === true) {
                            this.$('.input-default-status').prop('checked', true);
                            this.$('.input-default-status').prop('disabled', true);
                        } else {
                            this.$('.input-default-status').prop('checked', false);
                            this.$('.input-default-status').prop('disabled', false);
                        }

                        return '<div>' + content + '</div>'
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "200px",
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.taskStatusContext != null && this.taskStatusContext.get('name') === row.get('name')) {
                            return '<div class="input-group task-status-color-input wd-200p"><input type="text" class="form-control colorpicker-input-box"/><span class="input-group-append"><div class="input-group color-picker"><span class="input-group-text colorpicker-input-addon"><i></i></span></div></span></div>'
                        }
                        return '<div>' + content + '</div>'
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.taskStatusContext != null && this.taskStatusContext.get('name') === row.get('name')) {
                            content = '<button type="button" class="btn btn-success save-task-status wd-30p ml-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger cancel-edit-task-status wd-30p ml-1"><i class="fal fa-times"></i></button>';
                        } else {
                            let disabledAttr = this.taskStatusContext != null ? ' disabled ' : '';
                            content = '<button type="button" class="btn btn-info edit-task-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger delete-task-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
                        }
                        return '<div class="text-align-right show-on-row-hover">' + content + '</div>'
                    }, this),
                    "width": "80px",
                }
            ],
        });
    },
    addClicked: function () {
        this.taskStatusContext = null;
        if (this.collection.models.length > 0 && this.collection.models[0].get('userId') === -1)
            this.copyDefaultStatuses(_.bind(this.addStatus, this));
        else
            this.addStatus();
    },
    addStatus: function () {
        let newStatus = new PJQ.models.schedule.TaskStatus({
            name: "",
            color: "#000000",
            isDefault: false,
            sortOrder: this.collection.models.length + 1,
        });
        this.dataTable.addRow(newStatus);
        this.taskStatusContext = newStatus;
        this.$('.add-task-status').prop('disabled', true);
        this.dataTable.refresh();
        this.colorPicker = new PJQ.colors.ColorPicker(this.$('.color-picker'), {
            format: 'hex',
            color: this.taskStatusContext.get('color'),
            autoInputFallback: false
        });
        this.$('.colorpicker-input-box').val(this.taskStatusContext.get('color'));
        this.$('.input-task-status').css('color', this.taskStatusContext.get('color'));
    },
    editClicked: function (e) {
        this.taskStatusContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
        if (this.taskStatusContext.get('userId') === -1)
            this.copyDefaultStatuses(_.bind(function (newStatus) {
                this.taskStatusContext = newStatus;
                this.editStatus();
            }, this));
        else
            this.editStatus();
    },
    editStatus: function () {
        this.$('.add-task-status').prop('disabled', true);
        this.dataTable.refresh();
        this.colorPicker = new PJQ.colors.ColorPicker(this.$('.color-picker'), {
            format: 'hex',
            color: this.taskStatusContext.get('color'),
            autoInputFallback: false
        });
        this.$('.colorpicker-input-box').val(this.taskStatusContext.get('color'));
        this.$('.input-task-status').css('color', this.taskStatusContext.get('color'));
    },
    setBGColor: function (e) {
        if (e.type === 'keyup') {
            if (e.keyCode === 13) {
                $(e.currentTarget).blur()
            }
            let color = this.$('.colorpicker-input-box').val();
            if (color.split('')[0] === '#' && color.trim().length === 7) {
                this.colorPicker.setColor(color);
                this.taskStatusContext.set('color', color.toUpperCase());
                this.$('.input-task-status').css('color', color.toUpperCase());
                PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
            }
        } else {
            let color = this.colorPicker.getColor();
            if (color.split('')[0] === '#' && color.trim().length === 7) {
                this.$('.colorpicker-input-box').val(color);
                this.taskStatusContext.set('color', color);
                this.$('.input-task-status').css('color', color);
                PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
            }
        }
    },
    statusSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            status = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-task-status'),
            color = this.$('.colorpicker-input-box').val(),
            isColorValid = color.split('')[0] === '#' && color.trim().length === 7;

        if (_.size($name) > 0) {
            status.set('name', $name.val())
        }
        let isNameValid = _.size(status.get('name')) > 0;

        status.set('color', color);
        status.set('isDefault', (this.$('.input-default-status').prop('checked')));
        status.set('sortOrder', this.taskStatusContext.get('sortOrder'));

        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), isColorValid, {
            errorText: isColorValid ? "" : "Hex must begin with a # followed by 6 letters and/or numbers!"
        });

        let isDefault = status.get('isDefault'),
            successFn = _.bind(function (isDefault) {
                if (isDefault) {
                    _.each(this.collection.models, _.bind(function (status) {
                        if (status.get('statusId') !== this.taskStatusContext.get('statusId'))
                            status.set('isDefault', false);
                    }, this));
                }
                this.taskStatusContext = null;
                this.render()
            }, this);

        if (isNameValid && isColorValid) {
            let wasNew = this.taskStatusContext.isNew();
            this.taskStatusContext.save(null, {
                success: _.bind(function () {
                    if (wasNew)
                        this.collection.add(this.taskStatusContext);
                    successFn(isDefault);
                }, this)
            });
        }
    },
    cancelEditStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        if (this.taskStatusContext.get('name').length === 0) {
            this.dataTable.removeRow(row);
        }
        this.$('.add-task-status').prop('disabled', false);
        this.taskStatusContext = null;
        this.dataTable.refresh();

    },
    deleteClicked: function (e) {
        this.taskStatusContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();

        if (this.taskStatusContext.get('userId') === -1)
            this.copyDefaultStatuses(_.bind(function (newStatus) {
                this.taskStatusContext = newStatus;
                this.deleteStatus(e);
            }, this));
        else
            this.deleteStatus(e);
    },
    deleteStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Task Status",
            body: "Are you sure you want to delete this status?  All tasks that have this status will be set to the Default status if you continue.",
            onDelete: _.bind(function () {
                this.dataTable.removeRow(row);
                this.dataTable.refresh();

                let wasDefault = this.taskStatusContext.get('isDefault');
                this.taskStatusContext.destroy();
                this.taskStatusContext = null;
                _.each(this.collection.models, _.bind(function (status, index) {
                    status.set('sortOrder', index + 1);
                }, this));

                if (wasDefault && this.collection.models.length > 0)
                    this.collection.models[0].set('isDefault', true);

                this.render();
            }, this)
        });

    },
    copyDefaultStatuses: function (callback) {
        new PJQ.views.modals.YesNo({
            header: "Change Task Statuses?",
            body: 'You are currently using the system default task statuses.  To edit a task status, we will need to create custom task statuses for your company.  This may take a minute, would you like to continue?',
            onYes: _.bind(function () {
                this.collection.copy(_.bind(function () {
                    let newStatus = null;
                    if (this.taskStatusContext != null) {
                        let returnName = this.taskStatusContext.get('name');
                        newStatus = _.find(this.collection.models, function (u) {
                            return u.get('name') === returnName;
                        });
                    }
                    this.dataTable.options.data = this.collection.models
                    this.dataTable.render();
                    callback(newStatus);
                }, this));
            }, this)
        });
    }
});
